import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { Icon } from '../Icon';
var SignalLoadingSvg = function SignalLoadingSvg() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m7 7.249.959.959-4.041 4.041 4.041 4.041L7 17.25l-5-5zM20.082 12.249l-4.041-4.041.959-.959 5 5-5 5-.959-.959z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M9.514 11.345H7.705v1.808h1.809zM11.096 11.345h1.808v1.808h-1.808zM16.294 11.345h-1.808v1.808h1.808z"
  }));
};
export var SignalLoading = function SignalLoading(props) {
  return /*#__PURE__*/React.createElement(Icon, _extends({}, props, {
    component: SignalLoadingSvg
  }));
};